import { defineStore } from 'pinia';

export const useAuthStore = defineStore("auth", {
    state: () => ({
        token: localStorage.getItem('token') || "",
        user: localStorage.getItem('user') || "{}",
        systemPermissions: JSON.parse(localStorage.getItem('systemPermissions') || "{}"),
    }),
    actions: {
        setToken(token) {
            this.token = token;
            localStorage.setItem('token', token);
        },
        setUser(userData) {
            this.user = userData;
            localStorage.setItem('user', userData);
        },
        setSystemPermissions(permissions) {
            this.systemPermissions = permissions;
            localStorage.setItem('systemPermissions', JSON.stringify(permissions));
        },
        logout() {
            this.token = '';
            this.user = null;
            this.systemPermissions = {};
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            localStorage.removeItem('systemPermissions');
        },
    },
});